import {collection, EntityData, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {AbstractBIPageData} from "../bi-page/bi-page.data";

export class PivotGridAxisData extends EntityData<PivotGridAxisData> {
    @identifier id: number;
    @collection() dimensions: string[];
}

export class PivotGridData extends AbstractBIPageData<PivotGridData> {
    @collection() rowMeasures: string[];
    @collection() columnMeasures: string[];
    @collection() slicers: string[];
    @collection(PivotGridAxisData) columns: PivotGridAxisData[];
    @collection(PivotGridAxisData) rows: PivotGridAxisData[];
}
